import { render, staticRenderFns } from "./InfoPlain.vue?vue&type=template&id=6645b07c&"
import script from "./InfoPlain.vue?vue&type=script&lang=js&"
export * from "./InfoPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports